export const appsApiUsageAlertDatatable = "/api_usage_alert/datatable";
